const da = require('./da'),
      cq = require('./cq'),
      db = require('./db');

module.exports = {da, cq, db};
